(function () {
  'use strict';
  if (window.CardWhite) return;
  var selector = '.product-item__aspect-ratio > img, .product__media-image-wrapper > img, .product__thumbnail > img[data-white-gallery]';
  var cache = new Map(), jobs = [], running = 0;
  // Compare to the corner background, never apply a global color filter.
  function whiten(image, limit) {
    var canvas = document.createElement('canvas');
    var scale = Math.min(1, limit / Math.max(image.naturalWidth, image.naturalHeight));
    canvas.width = Math.round(image.naturalWidth * scale);
    canvas.height = Math.round(image.naturalHeight * scale);
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx || !canvas.width || !canvas.height) return null;
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height), data = pixels.data;
    var w = canvas.width, h = canvas.height, count = w * h;
    var corners = [0, w - 1, (h - 1) * w, count - 1];
    var samples = corners.map(function (p) { return [data[p * 4], data[p * 4 + 1], data[p * 4 + 2]]; });
    if (samples.some(function (c) { return Math.min.apply(null, c) < 210 || Math.max.apply(null, c) - Math.min.apply(null, c) > 20; })) return null;
    var reference = [0, 1, 2].map(function (channel) {
      return samples.reduce(function (sum, c) { return sum + c[channel]; }, 0) / 4;
    });
    if (samples.some(function (c) { return c.some(function (v, channel) { return Math.abs(v - reference[channel]) > 8; }); })) return null;
    if (Math.min.apply(null, reference) >= 253) return null;
    var seen = new Uint8Array(count), queue = new Int32Array(count), head = 0, tail = 0;
    function push(p) {
      if (seen[p]) return;
      seen[p] = 1;
      var i = p * 4;
      if (data[i + 3] < 245) return;
      // A narrow background-color range deliberately leaves ambiguous shadows
      // and similarly colored product details alone rather than recoloring them.
      for (var c = 0; c < 3; c++) if (Math.abs(data[i + c] - reference[c]) > 9) return;
      queue[tail++] = p;
    }
    for (var x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (var y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
    while (head < tail) {
      var p = queue[head++];
      if (p % w > 0) push(p - 1);
      if (p % w < w - 1) push(p + 1);
      if (p >= w) push(p - w);
      if (p < count - w) push(p + w);
    }
    if (tail < count * 0.12 || tail > count * 0.96) return null;
    for (var k = 0; k < tail; k++) {
      var offset = queue[k] * 4;
      data[offset] = data[offset + 1] = data[offset + 2] = 255;
    }
    ctx.putImageData(pixels, 0, 0);
    return canvas;
  }
  function pump() {
    while (running < 4 && jobs.length) {
      running++;
      jobs.shift()();
    }
  }
  function converted(source, limit) {
    var key = source + '|' + limit;
    if (cache.has(key)) return cache.get(key);
    var promise = new Promise(function (resolve) {
      jobs.push(function () {
        var original = new Image(); original.crossOrigin = 'anonymous';
        function finish(url) { resolve(url); running--; pump(); }
        original.onload = function () {
          try {
            var canvas = whiten(original, limit);
            if (!canvas) { finish(null); return; }
            canvas.toBlob(function (blob) { finish(blob ? URL.createObjectURL(blob) : null); }, 'image/jpeg', 0.95);
          } catch (error) { finish(null); }
        };
        original.onerror = function () { finish(null); };
        original.src = source;
      });
    });
    cache.set(key, promise); pump();
    return promise;
  }
  // Each image stays hidden only until its own white version is ready. If that
  // takes too long the original is shown and is never swapped afterwards, so
  // the visitor never sees one background turn into another.
  function reveal(img, url) {
    if (img.dataset.cardWhite) return;
    if (!url) { img.dataset.cardWhite = 'original'; return; }
    var ready = new Image();
    ready.onload = ready.onerror = function () {
      if (img.dataset.cardWhite) return;
      img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url;
      img.dataset.cardWhite = 'done';
    };
    ready.src = url;
  }
  function process(img) {
    if (img.hidden || img.dataset.cardWhite) return;
    if (!img.complete) return;
    if (!img.naturalWidth) { img.dataset.cardWhite = 'original'; return; }
    var source = img.currentSrc || img.src;
    if (!source || source.indexOf('blob:') === 0 || img.dataset.cardWhiteSource === source) return;
    img.dataset.cardWhiteSource = source;
    var gallery = img.closest('.product__media-image-wrapper');
    var shown = Math.max(img.clientWidth, img.clientHeight, 300) * Math.min(window.devicePixelRatio || 1, 2);
    var limit = Math.round(Math.min(gallery ? 2400 : 1000, Math.max(shown, 400)) / 100) * 100;
    setTimeout(function () { if (!img.dataset.cardWhite) img.dataset.cardWhite = 'original'; }, 2500);
    converted(source, limit).then(function (url) {
      if (!img.isConnected || (img.currentSrc || img.src) !== source) return;
      reveal(img, url);
    });
  }
  var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) { if (entry.isIntersecting) process(entry.target); });
  }, { rootMargin: '800px' }) : null;
  function init() {
    document.querySelectorAll(selector).forEach(function (img) {
      if (img.dataset.cardWhiteBound) return;
      img.dataset.cardWhiteBound = '1';
      img.addEventListener('load', function () { process(img); });
      if (observer) observer.observe(img); else process(img);
    });
  }
  window.CardWhite = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function (records) {
    var added = false;
    records.forEach(function (record) {
      if (record.type === 'childList' && record.addedNodes.length) added = true;
      if (record.type === 'attributes' && record.target.matches(selector) && record.target.dataset.cardWhite !== 'done') process(record.target);
    });
    if (added) init();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'hidden'] });
})();